export enum VerificationActionEnum {
	EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
	MFA_REMOVAL = 'MFA_REMOVAL'
}
